import { Components } from '@mui/material/styles/components';
import { ControllerOutlinedInputColor } from '../../palette';
import theme from '../../provider/controllerBaseTheme';

export const OutlinedInputComponent: Components = {
  MuiOutlinedInput: {
    defaultProps: {
      notched: false,
    },
    styleOverrides: {
      root: {
        lineHeight: theme.spacing(2.5),
        '&.Mui-error': {
          paddingRight: theme.spacing(1),
        },
        '&.Mui-disabled': {
          backgroundColor: String(ControllerOutlinedInputColor.DisabledBg),
          color: String(ControllerOutlinedInputColor.DisabledFg),
        },
        '&.Mui-focused $notchedOutline': {
          borderColor: String(ControllerOutlinedInputColor.FocusBorder),
        },
        '&.Mui-disabled $notchedOutline': {
          borderColor: String(ControllerOutlinedInputColor.DisabledBorder),
        },
        '&.Mui-error $notchedOutline': {
          borderColor: String(ControllerOutlinedInputColor.ErrorBorder),
        },
        '&:hover:not(.Mui-focused):not(.Mui-error):not(.Mui-disabled) $notchedOutline': {
          borderColor: String(ControllerOutlinedInputColor.HoverBorder),
          borderWidth: 2,
        },

        //
        // mason classes
        //
        '& .MasonOutlinedInputErrorIcon': {
          color: String(ControllerOutlinedInputColor.ErrorIconFill),
          fontSize: theme.spacing(2),
          height: theme.spacing(2),
          lineHeight: theme.spacing(2),
        },
      },
      notchedOutline: {
        borderColor: String(ControllerOutlinedInputColor.DefaultBorder),
        '&>legend': {
          width: 0,
        },
      },
      multiline: { padding: 0 },
    },
  },
};
